import { render, staticRenderFns } from "./JobAlerts.vue?vue&type=template&id=3b145f54&"
import script from "./JobAlerts.vue?vue&type=script&lang=js&"
export * from "./JobAlerts.vue?vue&type=script&lang=js&"
import style0 from "./JobAlerts.vue?vue&type=style&index=0&id=3b145f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports